/**
 * Calendar & Scheduling Icons
 * 
 * Icons for date/time selection, event scheduling, and calendar views.
 * 
 * Used by: Calendar components, event scheduling, date pickers
 */

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCalendar as fadCalendar,
  faCalendarDay as fadCalendarDay,
  faCalendarClock as fadCalendarClock,
  faCalendarWeek as fadCalendarWeek,
  faCalendarCheck as fadCalendarCheck,
  faCalendarPlus as fadCalendarPlus,
  faCalendarXmark as fadCalendarXmark,
  faCalendarStar as fadCalendarStar,
  faCalendarDays as fadCalendarDays,
  faCalendarRange as fadCalendarRange,
  faClock as fadClock,
  faTimer as fadTimer,
  faClockRotateLeft as fadClockRotateLeft,
  faHourglassClock as fadHourglassClock,
  faHourglassHalf as fadHourglassHalf,
} from "@fortawesome/pro-duotone-svg-icons";

// Note: fadCalendarDays2 is an alias to avoid naming collision
import {
  faCalendarDays as fadCalendarDays2,
} from '@fortawesome/pro-duotone-svg-icons';

export const loadCalendarIcons = () => {
  library.add(
    fadCalendar,
    fadCalendarDay,
    fadCalendarClock,
    fadCalendarWeek,
    fadCalendarCheck,
    fadCalendarPlus,
    fadCalendarXmark,
    fadCalendarStar,
    fadCalendarDays,
    fadCalendarDays2,
    fadCalendarRange,
    fadClock,
    fadTimer,
    fadClockRotateLeft,
    fadHourglassClock,
    fadHourglassHalf,
  );
};
